import type { CopyShape } from "@tami/core/intl";

import type { APP_PAGES_COPY_PT_BR } from "../pages.copy";

export const APP_PAGES_COPY_EN_US: CopyShape<typeof APP_PAGES_COPY_PT_BR> = {
  error: {
    title: "Something went wrong!",
    description: "Looks like our server hit an unexpected problem. 😔",
    back: "Go back",
  },
  notFound: {
    title: "Page not found :(",
    description: "Looks like the page you asked for couldn't be found.",
    back: "Go back",
    reload: "Reload",
  },
  demo: {
    title: "Interactive demo",
    description:
      "Take a look inside Tãmi: content, campaigns, calendar, finances and the WhatsApp assistant. Click the highlighted spots or let the guided tour show you around.",
    heading: "Tãmi interactive demo",
    backAria: "Back to the website",
    back: "Go back",
    signUp: "Create a free account",
  },
  links: {
    title: "Links",
    description:
      "Create your account, check out the demo and talk to us: all of Tãmi's links, the tool that keeps creators' and Collabs' lives organized.",
  },
  signTagline: "You create. Tãmi organizes.",
  dataDeletion: {
    metaTitle: "Data deletion request",
    title: "Data deletion request received",
    received: "Your Instagram data deletion request has been received and processed.",
    revokeIntro:
      "When you revoke Tãmi's access to your Instagram or request deletion of your data directly through Meta, we immediately delete:",
    deletedConnection: "the connection between your Tãmi account and your Instagram account;",
    deletedToken: "the access token tied to that connection;",
    deletedMetrics: "the Instagram followers, posts and metrics we had stored.",
    immediate:
      "This deletion happens as soon as we get the request — you don't need to do anything else — and no new data is collected from Instagram from then on. Nothing on Instagram itself is affected. To track your performance on Tãmi again, just reconnect your account.",
    contactBefore: "If you have any questions about the deletion, write to",
    supportEmail: "suporte@tamiapp.com",
    contactAfter: ". We reply within 15 days, as required by Brazil's LGPD.",
    questionsBefore: "Questions about how we handle your data can be answered in our",
    privacyLink: "privacy policy",
  },
};
